/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Listingbuttonscount2Inputs */

const en_listingbuttonscount2 = /** @type {(inputs: Listingbuttonscount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of ${i?.max}`)
};

const de_listingbuttonscount2 = /** @type {(inputs: Listingbuttonscount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} von ${i?.max}`)
};

/**
* | output |
* | --- |
* | "{count} of {max}" |
*
* @param {Listingbuttonscount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonscount2 = /** @type {((inputs: Listingbuttonscount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonscount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonscount2(inputs)
	return de_listingbuttonscount2(inputs)
});
export { listingbuttonscount2 as "listingButtonsCount" }